var actionStrip = '_1ymwlhzx';
var arrow = {top:'_1ymwlhz7 _1ymwlhz6',right:'_1ymwlhz8 _1ymwlhz6',bottom:'_1ymwlhz9 _1ymwlhz6',left:'_1ymwlhza _1ymwlhz6'};
var body = '_1ymwlhzq _14wijgr9';
var bodyInner = '_1ymwlhzt _14wijgr9';
var bodyNoScroll = '_1ymwlhzr';
var bodyScrollContainer = '_1ymwlhzs';
var close = '_1ymwlhzh';
var closeTheme = {light:'_1ymwlhzj',dark:'_1ymwlhzk'};
var contentsLayout = {'sidebar-full-height':'_1ymwlhz4 _1ymwlhz3 _1ymwlhz2','footer-full-width':'_1ymwlhz5 _1ymwlhz3 _1ymwlhz2'};
var customClose = '_1ymwlhzi';
var customContents = '_1ymwlhz2';
var customFooter = 'rbx6no0 _14wijgr9 _1ymwlhzu';
var customHeader = '_1ymwlhze _1ymwlhzd';
var formContents = '_14wijgr1';
var hasCustomClose = '_1ymwlhzb';
var header = '_1ymwlhzf _1ymwlhzd';
var hiddenTitle = '_14wijgr0';
var noCloseButton = '_1ymwlhzc';
var styledFooter = 'rbx6no1 rbx6no0 _14wijgr9 _1ymwlhzu';
var tabStripContent = '_1ymwlhzm';
var tabStripRoot = '_1ymwlhzl';
var tabStripScroll = {houdini:'_1ymwlhzo _1ymwlhzn',noHoudini:'_1ymwlhzp _1ymwlhzn'};
var title = '_1ymwlhzg _14wijgra';

export { actionStrip, arrow, body, bodyInner, bodyNoScroll, bodyScrollContainer, close, closeTheme, contentsLayout, customClose, customContents, customFooter, customHeader, formContents, hasCustomClose, header, hiddenTitle, noCloseButton, styledFooter, tabStripContent, tabStripRoot, tabStripScroll, title };
//# sourceMappingURL=dialog-common.css.js.map
